module.exports = __webpack_public_path__ + "static/gotdone-a69a7ac8fe86930b9518e03fd67fb596.png";